//= Functions & Modules
// Others
import React from 'react';

export const PermissionsContext = React.createContext<string[]>([]);
